import React from 'react';
import { NumberMaskedField, NumberMaskedFieldProps } from '../NumberMaskedField';
import { NumberFormatProps } from 'react-number-format';

export type PercentageFieldProps = NumberMaskedFieldProps;

const defaultMaskedProps: NumberFormatProps = {
  suffix: '%',
};

export const PercentageField = ({ MaskedProps, ...props }: PercentageFieldProps): JSX.Element => {
  return <NumberMaskedField MaskedProps={{ ...defaultMaskedProps, ...MaskedProps }} {...props} />;
};
